import {TableBodyBase} from './TableBodyBase';
import {withComponent} from '../../hoc/withComponent';

export const withTableBody = withComponent(TableBodyBase);
